// extracted by mini-css-extract-plugin
export var barContainer = "_2e-0";
export var extraThin = "_2e-3";
export var fillBar = "_2e-6";
export var fillContainer = "_2e-4";
export var overflow = "_2e-8";
export var overflowContainer = "_2e-5";
export var regular = "_2e-7";
export var thick = "_2e-1";
export var thin = "_2e-2";